/**
 * Utilidades para manejo de dispositivos y sesiones únicas
 */

/**
 * Generar un UUID v4 simple
 */
function generateUUID(): string {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    const r = Math.random() * 16 | 0;
    const v = c === 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}

/**
 * Obtener o generar deviceId único para este navegador
 */
export function getDeviceId(): string {
  const DEVICE_ID_KEY = 'enarm360_device_id';
  
  let deviceId = localStorage.getItem(DEVICE_ID_KEY);
  
  if (!deviceId) {
    deviceId = generateUUID();
    localStorage.setItem(DEVICE_ID_KEY, deviceId);
    console.info('🆔 Nuevo dispositivo registrado:', deviceId);
  }
  
  return deviceId;
}

/**
 * Detectar tipo de dispositivo basado en User-Agent
 */
export function getDeviceType(): string {
  const ua = navigator.userAgent.toLowerCase();
  
  if (/android/i.test(ua)) {
    return 'MOBILE_ANDROID';
  }
  
  if (/iphone|ipad|ipod/i.test(ua)) {
    return 'MOBILE_IOS';
  }
  
  // Para aplicaciones móviles híbridas
  if (/mobile/i.test(ua)) {
    return 'MOBILE';
  }
  
  return 'WEB';
}

/**
 * Obtener información completa del dispositivo para login
 */
export function getDeviceInfo() {
  return {
    deviceId: getDeviceId(),
    deviceType: getDeviceType(),
    userAgent: navigator.userAgent
  };
}

/**
 * Limpiar deviceId (útil para testing o logout completo)
 */
export function clearDeviceId(): void {
  localStorage.removeItem('enarm360_device_id');
}

/**
 * Generar nombre amigable del dispositivo para mostrar al usuario
 */
export function getDeviceName(): string {
  const type = getDeviceType();
  const ua = navigator.userAgent;
  
  switch (type) {
    case 'WEB':
      return `${getBrowserName()} (Navegador)`;
    case 'MOBILE_ANDROID':
      return 'Dispositivo Android';
    case 'MOBILE_IOS':
      return 'iPhone/iPad';
    default:
      return `Dispositivo ${type}`;
  }
}

/**
 * Extraer nombre del navegador
 */
function getBrowserName(): string {
  const ua = navigator.userAgent;
  
  if (/Chrome/i.test(ua) && !/Edge/i.test(ua)) {
    return 'Chrome';
  }
  
  if (/Firefox/i.test(ua)) {
    return 'Firefox';
  }
  
  if (/Safari/i.test(ua) && !/Chrome/i.test(ua)) {
    return 'Safari';
  }
  
  if (/Edge/i.test(ua)) {
    return 'Edge';
  }
  
  if (/Opera/i.test(ua)) {
    return 'Opera';
  }
  
  return 'Otro navegador';
}

/**
 * Obtener sistema operativo
 */
export function getOSName(): string {
  const ua = navigator.userAgent;
  
  if (/Windows/i.test(ua)) {
    return 'Windows';
  }
  
  if (/Macintosh|Mac OS/i.test(ua)) {
    return 'macOS';
  }
  
  if (/Linux/i.test(ua)) {
    return 'Linux';
  }
  
  if (/Android/i.test(ua)) {
    return 'Android';
  }
  
  if (/iPhone|iPad/i.test(ua)) {
    return 'iOS';
  }
  
  return 'Otro SO';
}